export default __webpack_public_path__ + "static/media/7.694be695.jpg";